import { Component, computed, inject } from '@angular/core';
import { clsx } from 'clsx';

import { FormFieldControlDirective } from '../form-field/sb-form-field-control.directive';
import { RadioBaseGroupDirective } from '../radio-base/radio-base-group.directive';

@Component({
  selector: 'sb-radio-badge-group',
  template: `<ng-content />`,
  // FormFieldControlDirective publishes the form-field contract on the group host
  // (role=radiogroup/group — non-labelable, so the field names it via
  // aria-labelledby). The field's content query resolves to this group, not a
  // nested sb-radio-badge, because the group is the ancestor in DOM order.
  hostDirectives: [
    { directive: RadioBaseGroupDirective, inputs: ['multiple', 'disabled', 'name', 'value', 'orientation'] },
    { directive: FormFieldControlDirective, inputs: ['id', 'hasError'] },
  ],
  host: {
    '[class]': 'hostClasses()',
  },
})
export class RadioBadgeGroupComponent {
  #group = inject(RadioBaseGroupDirective);

  // gap-2 kept verbatim for visual parity — restyling is SHB-21150
  hostClasses = computed(() =>
    clsx('flex flex-wrap gap-2', this.#group.orientation() === 'horizontal' ? 'flex-row' : 'flex-col'),
  );
}
